export { ContactPage } from './Contact'
